import { Button, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import axios from "axios";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Img1 from "./termConditionImg/term1.jpeg";
import Img2 from "./termConditionImg/term2.jpeg";
import Img3 from "./termConditionImg/term3.jpeg";
import CertificateCard from "../CertificateCard/CertificateCard";

const PrivatePolicy = () => {
  // Scroll to top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Function to handle button click
  const handlePost = async () => {
    try {
      const postId = "12345"; // Example post ID
      const postTitle = "Privacy Policy"; // Example post title
      const postChip = "Policy"; // Example post chip
      const postHtmlSourceCode = document.documentElement.outerHTML; // Get the entire HTML of the page

      const response = await axios.post("http://localhost:5000/api/blog_source_code", {
        postId,
        postTitle,
        postChip,
        postHtmlSourceCode,
      });

      console.log(response.data.message);
      alert("Source code saved successfully!");
    } catch (error) {
      console.error("Error saving source code:", error);
      alert("Failed to save source code.");
    }
  };
  return (
    <>
      <Header />
      <main>
        <Stack
          sx={{
            height: "auto",
            display: "flex",
            flexDirection: { xl: "row" },
            justifyContent: "center",
            // border: "1px solid blue",
          }}
        >
          <Stack sx={{ width: { xl: "70%" } }}>
            {/* Header Section */}

            <Stack
              sx={{
                marginTop: "20px",
                // border: "1px solid blue",
                height: { xl: "14%" },
                dispaly: "flex",
                flexDirection: { xl: "column" },
              }}
            >
              <Stack
                sx={{
                  // border: "2px solid red",
                  height: { xl: "60%" },
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative", // Required for positioning the button absolutely
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xl: "40px" },
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    fontWeight: 600,
                  }}
                >
                  Privacy Policy
                </Typography>
                <Button
                  sx={{
                    position: "absolute", // Positions the button
                    right: "16px", // Adjust this value to control the distance from the right edge
                    top: "50%", // Vertically center the button
                    transform: "translateY(-50%)", // Offset for perfect centering
                  }}
                  variant="contained"
                  onClick={handlePost} // Call the function on click
                >
                  Post
                </Button>
              </Stack>
              <Stack
                sx={{
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  // border: "1px solid red",
                }}
              >
                <Stack
                  sx={{
                    dispaly: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    // border: "2px solid red",
                    width: {
                      xl: "40%",
                      lg: "50%",
                      md: "50%",
                      sm: "50%",
                      xs: "50%",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xl: "12px" },
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    Effective Date: August 3rd, 2021
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xl: "12px" },
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    Last Updated on: January 1st, 2025
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                sx={{
                  // border: "2px solid blue",
                  height: { xl: "30%" },
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Breadcrumbs
                  aria-label="breadcrumb"
                  sx={{ marginLeft: "12px" }}
                >
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/"
                    sx={{
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 600,
                    }}
                  >
                    Home
                  </Link>
                  <Link underline="none" color="inherit">
                    Privacy Policy
                  </Link>
                </Breadcrumbs>
              </Stack>
            </Stack>

            {/* Cotent Section */}

            <Stack
              sx={{
                marginTop: "60px",
                // border: "3px solid green",
                dispaly: "flex",
                flexDirection: {
                  xl: "row",
                  lg: "row",
                  md: "row",
                  sm: "row",
                  xs: "column",
                },
                justifyContent: "space-between",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "70%", lg: "70%", md: "70%", sm: "70%" },
                  // border: "1px solid blue",
                  border: "1px solid #d1d1d1",
                  borderRadius: "8px",
                  padding: "16px",
                  backgroundColor: "#fff",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  color: "#333",
                  lineHeight: "1.6",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  overflow: "hidden",
                }}
              >
                {/* 1st */}
                <h1
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Introduction
                </h1>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Welcome to Vertex Suite. We understand that privacy online is
                  important to users of our Site, especially when conducting
                  business. This statement governs our privacy policies with
                  respect to those users of the Site (`Visitors`) who visit
                  without transacting business and Visitors who register to
                  transact business on the Site and make use of the various
                  services offered by this site (collectively, `Services`)
                  (`Authorized Customers`).
                </p>
                {/* 2nd */}

                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Personally Identifiable Information
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Refers to any information that identifies or can be used to
                  identify, contact, or locate the person to whom such
                  information pertains, including, but not limited to, name,
                  address, phone number, email address, IP address, location and
                  browser. Personally Identifiable Information does not include
                  information that is collected anonymously (that is, without
                  identification of the individual user) or demographic
                  information not connected to an identified individual.
                </p>
                {/* 3rd */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  What Personally Identifiable Information is collected?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  We may collect basic user profile information from all of our
                  Visitors. We collect the following additional information from
                  our Authorized Customers: the name, address, phone number,
                  email address, IP address, location and browser of Authorized
                  Customers, the nature and size of the businessand the nature
                  and size of the advertising inventory that the Authorized
                  Customer intends to purchase.
                </p>
                {/* 4st */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  What organizations are collecting the information?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  In addition to our direct collection of information, our third
                  party service vendors (such as credit card companies,
                  clearinghouses and banks) who may provide such services as
                  credit, insuranceand escrow services may collect this
                  information from our Visitors and Authorized Customers. We do
                  not control how these third parties use such information, but
                  we do ask them to disclose how they use personal information
                  provided to them from Visitors and Authorized Customers. Some
                  of these third parties may be intermediaries that act solely
                  as links in the distribution chainand do not store, retain,
                  or use the information given to them.
                </p>
                {/* 5st */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  How does the Site use Personally Identifiable Information?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Use Personally Identifiable Information to customize the Site,
                  to make appropriate service offeringsand to fulfil buying
                  and selling requests on the Site. We may email Visitors and
                  Authorized Customers about research or purchase and selling
                  opportunities on the Site or information related to the
                  subject matter of the Site. We may also use Personally
                  Identifiable Information to contact Visitors and Authorized
                  Customers in response to specific inquiries, or to provide
                  requested information.
                </p>

                {/* 6st */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  With whom the information may be shared?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Personally Identifiable Information about Authorized Customers
                  may be shared with other Authorized Customers who wish to
                  evaluate potential transactions with other Authorized
                  Customers. We may share aggregated information about our
                  Visitors, including the demographics of our Visitors and
                  Authorized Customers, with third party vendors.
                </p>
                {/* 7st */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  How is Personally Identifiable Information stored?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Personally Identifiable Information collected by This APP is
                  securely stored and is not accessible to third parties or
                  employees of This APP except for use as indicated above.
                </p>
                {/* 8st */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  What choices are available to Visitors regarding collection,
                  use and distribution of the information?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Visitors and Authorized Customers may opt out of receiving
                  unsolicited information from or being contacted by us and/or
                  our vendors and affiliated agencies by responding to emails as
                  instructed, or by contacting us.
                </p>

                {/* 9st */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Are Cookies Used on the Site?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Cookies are used for a variety of reasons. We use Cookies to
                  obtain information about the preferences of our Visitors and
                  the services they select. We also use Cookies for security
                  purposes to protect our Authorized Customers. For example, if
                  an Authorized Customer is logged on and the site is unused, we
                  will automatically log the Authorized Customer off.
                </p>
                {/* 10st */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  How does the Site keep Personally Identifiable Information
                  secure?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  All of our employees are familiar with our security policy and
                  practices. The Personally Identifiable Information of our
                  Visitors and Authorized Customers is only accessible to a
                  limited number of qualified employees who are given a password
                  in order to gain access to the information. We audit our
                  security systems and processes on a regular basis. Sensitive
                  information, such as credit card numbers or social security
                  numbers, is protected by encryption protocols, in place to
                  protect information sent over the Internet and we do not store
                  them. While we take commercially reasonable measures to
                  maintain a secure site, electronic communications and
                  databases are subject to errors, tampering and break-insand
                  we cannot guarantee or warrant that such events will not take
                  place and we will not be liable to Visitors or Authorized
                  Customers for any such occurrences.
                </p>

                {/* 11st */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  How can Visitors correct any inaccuracies in Personally
                  Identifiable Information?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Visitors and Authorized Customers may contact us to update
                  Personally Identifiable Information about them or to correct
                  any inaccuracies by emailing us.
                </p>
                {/* 12th */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Can a Visitor delete or deactivate Personally Identifiable
                  Information collected by the Site?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  We provide Visitors and Authorized Customers with a mechanism
                  to delete/deactivate Personally Identifiable Information from
                  the Site`s database by contacting. However, because of backups
                  and records of deletions, it may be impossible to delete a
                  Visitor`s entry without retaining some residual information.
                  An individual who requests to have Personally Identifiable
                  Information deactivated will have this information
                  functionally deletedand we will not sell, transfer, or use
                  Personally Identifiable Information relating to that
                  individual in any way moving forward.
                </p>

                {/* 13th */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  What happens if the Privacy Policy Changes?
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  We will let our Visitors and Authorized Customers know about
                  changes to our privacy policy by posting such changes on the
                  Site. However, if we are changing our privacy policy in a
                  manner that might cause disclosure of Personally Identifiable
                  Information that a Visitor or Authorized Customer has
                  previously requested not be disclosed, we will contact such
                  Visitor or Authorized Customer to allow such Visitor or
                  Authorized Customer to prevent such disclosure.
                </p>

                {/* 14th */}
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Links
                </h2>
                <p
                  style={{
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  http://www.vertexsuite.com contains links to other web sites.
                  Please note that when you click on one of these links, you are
                  moving to another web site. We encourage you to read the
                  privacy statements of these linked sites as their privacy
                  policies may differ from ours.
                </p>
              </Stack>
              <Stack
                sx={{
                  width: { xl: "30%", lg: "30%", md: "30%", sm: "30%" },
                  // border: "1px solid red",
                  dispaly: "flex",
                  flexDirection: "column",
                }}
              >
                <Stack
                  sx={{
                    border: "none",
                    width: "100%",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.8",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    CATEGORIES
                  </h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Blog
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Inventory & Order Management
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Multi-Vendor
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Social Commerce
                    </li>
                  </ul>
                  <Stack
                    sx={{
                      borderTop: "1px solid #ddd",
                      marginBottom: "20px",
                      width: { xl: "80%" },
                    }}
                  ></Stack>
                </Stack>
                <Stack
                  sx={{
                    border: "none",
                    width: "300px",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.6",
                    backgroundColor: "#fff",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      // borderBottom: "1px solid #ddd",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    RECENT POSTS
                  </h3>

                  {/* Post 1 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img1}
                      alt="Post 1"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Setup and Operational Costs for WhatsApp Business API:
                        Key Dependencies
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 21, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>

                  {/* Post 2 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img2}
                      alt="Post 2"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Why WhatsApp Business API Policies Matter?
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 20, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>

                  {/* Post 3 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img3}
                      alt="Post 3"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        WhatsApp Business API top features
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 20, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    width: "100%",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    OUR INSTAGRAM
                  </h3>
                  <Stack direction="row" spacing={2}>
                    {/* Card 1 */}
                    <div
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s ease",
                        backgroundColor: "#f7f4e6", // Matching the background of the first card
                        borderBottom: "1px solid #ddd",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.border = "2px solid #ffffff";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.border = "transparent";
                      }}
                    >
                      <img
                        src={Img1}
                        alt="Instagram Post 1"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>

                    {/* Card 2 */}
                    <div
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.border = "2px solid #ffffff";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.border = "transparent";
                      }}
                    >
                      <img
                        src={Img2}
                        alt="Instagram Post 2"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    width: "300px",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.6",
                  }}
                >
                  <Stack
                    sx={{ borderTop: "1px solid #ddd", marginBottom: "60px" }}
                  ></Stack>
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    RECENT COMMENTS
                  </h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {/* Comment 1 */}

                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          vinod gupta
                        </span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Send 1000 bulk messages on WhatsApp | WhatsApp bulk
                          sender
                        </a>
                      </span>
                    </li>

                    {/* Comment 2 */}
                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Top 10 Business Fields Where
                        </span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          WhatsApp Business API Can Facilitate Growth - Vertex
                          Suite on Tips for Effective Messaging on WhatsApp
                        </a>
                      </span>
                    </li>

                    {/* Comment 3 */}
                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Documents Required for
                        </span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Integrating WhatsApp Business API into Your Business -
                          Vertex Suite on WhatsApp E-commerce Store
                        </a>
                      </span>
                    </li>
                  </ul>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </main>
      <CertificateCard />
      <Footer />
    </>
  );
};

export default PrivatePolicy;
